import {
  BILLING_DETAILS,
  INVOICES,
  LOADING,
  PRICING_DETAILS,
  PRICING_LOADING,
} from "../actionType/paymentType";

const initialState = {
  loading: false,
  billingDetails: null,
  invoices: null,
  pricingDetails: null,
  pricingLoading: false,
};

const paymentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case BILLING_DETAILS:
      return { ...state, billingDetails: payload };
    case INVOICES:
      return { ...state, invoices: payload };
    case LOADING:
      return { ...state, loading: payload };
    case PRICING_DETAILS:
      return { ...state, pricingDetails: payload };
    case PRICING_LOADING:
      return { ...state, pricingLoading: payload };
    default:
      return state;
  }
};

export default paymentReducer;
